// tslint:disable
/**
 * GetInfo
 * Get info api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { LearningResourceInfo } from './learning-resource-info';

/**
 * 
 * @export
 * @interface SimpleContractEdit
 */
export interface SimpleContractEdit {
    /**
     * 
     * @type {string}
     * @memberof SimpleContractEdit
     */
    type: SimpleContractEditTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof SimpleContractEdit
     */
    companyId: string;
    /**
     * **Deprecated.**
     * @type {string}
     * @memberof SimpleContractEdit
     */
    clientType?: string;
    /**
     * **Deprecated.**
     * @type {string}
     * @memberof SimpleContractEdit
     */
    clientId?: string;
    /**
     * 
     * @type {string}
     * @memberof SimpleContractEdit
     */
    number: string;
    /**
     * 
     * @type {string}
     * @memberof SimpleContractEdit
     */
    responsibleId?: string;
    /**
     * 
     * @type {string}
     * @memberof SimpleContractEdit
     */
    contractorId?: string;
    /**
     * 
     * @type {string}
     * @memberof SimpleContractEdit
     */
    agentId?: string;
    /**
     * 
     * @type {string}
     * @memberof SimpleContractEdit
     */
    conditionId?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof SimpleContractEdit
     */
    userIds?: Array<string>;
    /**
     * 
     * @type {Array<LearningResourceInfo>}
     * @memberof SimpleContractEdit
     */
    learningResources?: Array<LearningResourceInfo>;
    /**
     * 
     * @type {string}
     * @memberof SimpleContractEdit
     */
    paymentConditions: string;
    /**
     * 
     * @type {number}
     * @memberof SimpleContractEdit
     */
    nds?: number;
    /**
     * 
     * @type {string}
     * @memberof SimpleContractEdit
     */
    comment?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof SimpleContractEdit
     */
    fileIds?: Array<string>;
    /**
     * 
     * @type {Date}
     * @memberof SimpleContractEdit
     */
    signedAt?: Date;
    /**
     * 
     * @type {Date}
     * @memberof SimpleContractEdit
     */
    formedAt: Date;
}

/**
    * @export
    * @enum {string}
    */
export enum SimpleContractEditTypeEnum {
    Contract = 'contract',
    Annex = 'annex'
}



